export async function loadTips() {
    const tips = {};
  
    const i18nContext = require.context('@/assets/tips/', true, /i18n\.json$/);
    const htmlContext = require.context('@/assets/tips/', true, /tip\.html$/);
    const imageContext = require.context('@/assets/tips/', true, /img\.jpg$/);
    
    // Import placeholder images
    const placeholderImage = require('@/assets/tips/placeholder.jpg');
    const placeholderImagePoprad = require('@/assets/tips/placeholder_poprad.jpg');
    const placeholderImageTatra = require('@/assets/tips/placeholder_tatra.jpg');
    const placeholderImageParadise = require('@/assets/tips/placeholder_paradise.jpg');
  
    i18nContext.keys().forEach((path) => {
      const pathParts = path.split('/');
      if (pathParts.length >= 3) { 
        const category = pathParts[1]; 
        const tipKey = pathParts[2]; 
        tips[tipKey] = {
          i18n: i18nContext(path),
          html: '',
          image: '',
          category: category
        };
      }
    });
  
    htmlContext.keys().forEach((path) => {
      const pathParts = path.split('/');
      if (pathParts.length >= 3) {
        const tipKey = pathParts[2];
        if (tips[tipKey]) {
          tips[tipKey].html = htmlContext(path);
        }
      }
    });
  
    imageContext.keys().forEach((path) => {
      const pathParts = path.split('/');
      if (pathParts.length >= 3) {
        const tipKey = pathParts[2];
        if (tips[tipKey]) {
          const img = imageContext(path);
          if (img && img.endsWith('.jpg')) {
            tips[tipKey].image = img;
          } else {
            if (tips[tipKey].category === 'poprad') {
              tips[tipKey].image = placeholderImagePoprad;
            } else if (tips[tipKey].category === 'tatra') {
              tips[tipKey].image = placeholderImageTatra;
            } else if (tips[tipKey].category === 'paradise') {
              tips[tipKey].image = placeholderImageParadise;
            } else {
              tips[tipKey].image = placeholderImage;
            }
          }
        }
      }
    });

    // For any tip that does not have an image assigned, set the appropriate placeholder image
    Object.keys(tips).forEach((tipKey) => {
      if (!tips[tipKey].image) {
        const category = tips[tipKey].category;
        if (category === 'poprad') {
          tips[tipKey].image = placeholderImagePoprad;
        } else if (category === 'tatra') {
          tips[tipKey].image = placeholderImageTatra;
        } else if (category === 'paradise') {
          tips[tipKey].image = placeholderImageParadise;
        } else {
          tips[tipKey].image = placeholderImage;
        }
      }
    });
    return tips;
  }